import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Verticals from "@/components/Verticals";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-mist text-navy-deep font-sans antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Verticals />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
